import {combineReducers} from "redux";
import ordersState from './orders/reducers';

export default combineReducers({ordersState});